export default __webpack_public_path__ + "static/media/lingerie.0262546d.jpg";